// extracted by mini-css-extract-plugin
module.exports = {"white":"HomepageAcademy_white__nsZmh"};